import * as z from "zod"
import { DBRepeatUnit } from ".prisma/client"
import { CompleteDBSupplierConnection, RelatedDBSupplierConnectionModel } from "./index"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]))

export const DBFtpConnectionModel = z.object({
  id: z.string(),
  supplierFileName: z.string(),
  fileLocation: z.string(),
  ftpHost: z.string(),
  ftpPort: z.string(),
  ftpUserName: z.string(),
  ftpPassword: z.string(),
  startUpdateTime: z.date(),
  extraEntries: jsonSchema,
  repeatEvery: z.number().int().nullish(),
  repeatUntil: z.nativeEnum(DBRepeatUnit),
  supplierConnectionId: z.string().nullish(),
  remark: z.string(),
})

export interface CompleteDBFtpConnection extends z.infer<typeof DBFtpConnectionModel> {
  supplierConnection?: CompleteDBSupplierConnection | null
}

/**
 * RelatedDBFtpConnectionModel contains all relations on your model in addition to the scalars
 *
 * NOTE: Lazy required in case of potential circular dependencies within schema
 */
export const RelatedDBFtpConnectionModel: z.ZodSchema<CompleteDBFtpConnection> = z.lazy(() => DBFtpConnectionModel.extend({
  supplierConnection: RelatedDBSupplierConnectionModel.nullish(),
}))
